import { SIDEBAR_COLLAPSE, SIDEBAR_EXPAND } from './actions';

export const collapseMenuAction = () => {
	return { type: SIDEBAR_COLLAPSE };
};
export const expandMenuAction = () => {
	return { type: SIDEBAR_EXPAND };
};
